import React from 'react';
import { useTranslation } from 'react-i18next';
import LoginForm from './Features/LoginForm/LoginForm';
import Terms from '../../Features/Terms/Terms';
import SocialLinks from '../../Features/SocialLinks/SocialLinks';
import AuthBetweenLink from '../../Features/AuthBetweenLink/AuthBetweenLink';
import styles from './LoginPageMobile.module.scss';
import LayoutMobileFixedHeight from '../../../Common/Mobile/Layout/FixedHeight/LayoutMobileFixedHeight';
import LayoutMobileBackHeader from '../../../Common/Mobile/Layout/BackHeader/LayoutMobileBackHeader';

function LoginPageMobile() {
  const { t } = useTranslation();
  return (
    <LayoutMobileFixedHeight>
      <LayoutMobileBackHeader>
        <div className={styles.container}>
          <span className={styles.title}>{t('login.action.title')}</span>
          <LoginForm withForgotPassword/>
          <Terms/>
          <div>
            <SocialLinks additionalText={t('login.action.social')}/>
          </div>
          <AuthBetweenLink title={t('login.action.signup1')} link={'/auth/signup'} linkText={t('login.action.signup2')}/>
        </div>
      </LayoutMobileBackHeader>
    </LayoutMobileFixedHeight>
  )
}

export default LoginPageMobile;
